import { AxiosStatic } from "axios";
import { TSendNotificationPayload } from "../types";
import { SEND_TIMEOUT_MS } from "../constants";

const postNotifications =
  (serverURL: string, appAxios: AxiosStatic, token: string) =>
  async ({
    namespace,
    templateId,
    authUserId,
    properties,
  }: TSendNotificationPayload): Promise<void> => {
    await appAxios.post(
      `${serverURL}/admin/notifications`,
      {
        namespace,
        authUserId,
        templateId,
        properties,
      },
      {
        timeout: SEND_TIMEOUT_MS,
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  };

export default postNotifications;
